import type { CrmExportResultDto } from "app/pages/sales-intelligence/domain/crm-integration/types/export";
import {
    type CrmIntegrationProvider,
    getApiPathForProvider
} from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import type { LeadsType } from "app/pages/sales-intelligence/domain/leads/types/lead";
import type {
    AccountsExportPreviewRequestDto,
    AccountsExportPreviewResponseDto,
    AccountsExportRequestDto,
} from "app/pages/sales-intelligence/modules/crm-export/types";
import type { IFetchService, PostConfigObject } from "app/services/fetchService";


export default function createAccountsCrmExportApiService(fetchService: IFetchService) {
    const getPathSegment = (leadsType: LeadsType): string => (leadsType === "companies" ? "companies/" : "");

    return {
        fetchAccountsExportPreview(
            payload: AccountsExportPreviewRequestDto,
            crm: CrmIntegrationProvider,
            leadsType: LeadsType,
            options?: PostConfigObject,
        ): Promise<AccountsExportPreviewResponseDto> {
            const apiPath = getApiPathForProvider(crm);
            const segment = getPathSegment(leadsType);

            return fetchService.post<AccountsExportPreviewResponseDto>(
                `/sales-api/${apiPath}/export/${segment}accounts/preview`,
                payload,
                options,
            );
        },

        exportAccountsToCrm(
            payload: AccountsExportRequestDto,
            crm: CrmIntegrationProvider,
            leadsType: LeadsType,
        ): Promise<CrmExportResultDto> {
            const apiPath = getApiPathForProvider(crm);
            const segment = getPathSegment(leadsType);

            return fetchService.post<CrmExportResultDto>(
                `/sales-api/${apiPath}/export/${segment}account`,
                payload,
            );
        },
    };
}
